import { Injectable } from '@angular/core';
import { BrowserInfo } from './model/adyen-browser-info';
@Injectable({
  providedIn: 'root'
})
export class AdyenBrowserInfoService {
  getBrowserInfo(): BrowserInfo {
    return {
      colorDepth: screen.colorDepth || 24,
      javaEnabled: false,
      javaScriptEnabled: true,
      language: navigator.language || 'en-US',
      screenHeight: screen.height,
      screenWidth: screen.width,
      timeZoneOffset: new Date().getTimezoneOffset()
    };
  }
}
